import { requestMain, requestBaseService } from './index'
import { generateQueryString } from '../../utils/query'

export const getFaqs = (payload) => {
  return requestBaseService({
    url: '/content/ex/v1/faqs',
    method: 'GET',
    params: payload
  })
}

export const getFaqDetails = payload => {
  return requestBaseService({
    url: `/content/ex/v1/faqs/${payload}`,
    method: 'GET',
  })
}

export const getFaqRelated = payload => {
  return requestBaseService({
    url: `/content/ex/v1/faqs/${payload}/related`,
    method: 'GET',
  })
}

export const postFaqRating = (data) => {
  return requestBaseService({
    url: '/content/ex/v1/faqs/rating',
    method: 'POST',
    data,
  })
}

export const getFaqFrequent = payload => {
  const params = generateQueryString(payload.params)
  return requestMain({
    url: 'faq-frequent?' + params,
    method: 'get'
  })
}

export const getFaqLast = () => {
  return requestMain({
    url: 'faq-last',
    method: 'get'
  })
}

export const getFaq = payload => {
  return requestMain({
    url: `faq/${payload.id}`,
    method: 'get'
  })
}

export const getFaqFree = (payload) => {
  return requestFreemium({
    url: `faq/${payload.id}`,
    method: 'get'
  })
}

const Faq = {
  getFaqs,
  getFaqDetails,
  getFaqRelated,
  postFaqRating,
  getFaqFrequent,
  getFaqLast,
  getFaq,
  getFaqFree,
}

export default Faq
